// todo - when adding a new page add also to ROUTE_TO_SCREEN_NAME
export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  PURCHASE: '/purchase',
  SETTINGS: '/settings',
  INSIGHTS: '/insights',
  WEB_HISTORY_CALLBACK: '/web_history_callback',
  BLOCKED: '/blocked',
  UNINSTALL: '/uninstall',
  CUSTOMIZE_BLOCK_PAGE: '/customize_block_page',
} as const;

export const QUERY_PARAM_TRUE = 'true';

export const QUERY_PARAMS = {
  WORD: 'word',
  BLOCK_TYPE: 'blockType',
  CATEGORY: 'category',
  SITE: 'site',
  ADD_ITEM_MODAL: 'addItemModal',
  SCHEDULE_MODAL: 'scheduleModal',
  SOURCE: 'source',
  GROUP_ID: 'groupId',
  CREATE_RULE: 'createRule',
  URL_TO_BLOCK: 'urlToBlock',
} as const;

export const LEGACY_ROUTES = {
  BLOCK_SITES: '/options/BLOCK_SITES',
  TIME_USAGE: '/options/TIME_USAGE',
  INSIGHTS: '/options/INSIGHTS',
  FOCUS_MODE: '/options/FOCUS_MODE',
  PASSWORD_PROTECTION: '/options/PASSWORD_PROTECTION',

  ACCOUNT: '/',
  SETTINGS: '/settings/account',
  REWARDS: '/rewards',
  SUPPORT: 'https://blocksite.zendesk.com/hc/en-us',
};

export const UNINSTALL_DATA_URL = 'https://blocksite.typeform.com/to/WIx0r3IX';
